"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _FormattedHTMLMessage = _interopRequireDefault(require("I18n/components/FormattedHTMLMessage"));

var _loggers = require("customer-data-tracking/loggers");

var _ProfileIntegrationLinkedSalesObjectItem = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/ProfileIntegrationLinkedSalesObjectItem"));

var _ProfileIntegrationsIframeModal = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/actions/ProfileIntegrationsIframeModal"));

var _ProfileIntegrationsLinkedSalesObjectFooter = _interopRequireDefault(require("crm_ui/profile/sidebar/integrations/ProfileIntegrationsLinkedSalesObjectFooter"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _UISection = _interopRequireDefault(require("UIComponents/section/UISection"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _default = (0, _createReactClass.default)({
  displayName: 'ProfileIntegrationsLinkedSalesObject',
  propTypes: {
    activeIframe: _propTypes.default.shape({
      action: _propTypes.default.instanceOf(_immutable.Map).isRequired,
      parentTitle: _propTypes.default.string
    }),
    associatedObjectId: _propTypes.default.number.isRequired,
    associatedObjectType: _propTypes.default.oneOf([_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL]).isRequired,
    closeIframeModal: _propTypes.default.func.isRequired,
    linkedSalesObject: _propTypes.default.instanceOf(_immutable.Map).isRequired,
    linkedSalesObjectContent: _propTypes.default.instanceOf(_immutable.Map),
    openIframeModal: _propTypes.default.func.isRequired
  },
  componentWillMount: function componentWillMount() {
    var linkedSalesObject = this.props.linkedSalesObject;
    return _loggers.CrmLogger.log('recordInteractionWithType', {
      action: 'view sidebar integration card',
      type: linkedSalesObject.get('appName', '')
    });
  },
  renderBody: function renderBody() {
    var _this$props = this.props,
        associatedObjectId = _this$props.associatedObjectId,
        associatedObjectType = _this$props.associatedObjectType,
        closeIframeModal = _this$props.closeIframeModal,
        linkedSalesObject = _this$props.linkedSalesObject,
        linkedSalesObjectContent = _this$props.linkedSalesObjectContent,
        openIframeModal = _this$props.openIframeModal;
    var results = linkedSalesObjectContent.getIn(['content', 'results']);

    if (linkedSalesObjectContent.get('error')) {
      return this.renderError();
    }

    if (!results.size) {
      return this.renderEmpty();
    }

    return _react.default.createElement(_UIList.default, null, results.map(function (item) {
      return _react.default.createElement(_ProfileIntegrationLinkedSalesObjectItem.default, {
        applicationId: linkedSalesObject.get('appId'),
        appName: linkedSalesObject.get('appName'),
        associatedObjectId: associatedObjectId,
        associatedObjectType: associatedObjectType,
        closeIframeModal: closeIframeModal,
        item: item,
        key: item.get('objectId'),
        objectTypeId: linkedSalesObject.get('objectTypeId'),
        openIframeModal: openIframeModal
      });
    }));
  },
  renderEmpty: function renderEmpty() {
    var content = this.props.linkedSalesObjectContent.get('content');
    var contentSecondaryAction = content.get('secondaryActions');

    if (content.has('primaryAction') || contentSecondaryAction && contentSecondaryAction.size || content.has('settingsAction')) {
      return null;
    }

    var itemLabel = content.get('itemLabel');

    if (itemLabel) {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrations.emptyWithLabel",
        options: {
          itemLabel: itemLabel
        }
      });
    } else {
      return _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrations.empty"
      });
    }
  },
  renderError: function renderError() {
    var name = this.props.linkedSalesObject.get('title');
    return _react.default.createElement(_FormattedHTMLMessage.default, {
      message: "profileSidebarModule.integrations.linkedSalesObjectLoadingError",
      options: {
        name: name
      }
    });
  },
  renderViewAllLink: function renderViewAllLink() {
    var message;
    var content = this.props.linkedSalesObjectContent.get('content');

    if (!content) {
      return null;
    }

    var allItemsLink = content.get('allItemsLink');
    var itemCount = content.get('totalCount');
    var itemLabel = content.get('itemLabel');

    if (!allItemsLink || !itemCount) {
      return null;
    }

    if (itemLabel) {
      message = _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrations.viewAllWithItemLabel",
        options: {
          count: itemCount,
          itemLabel: itemLabel
        }
      });
    } else {
      message = _react.default.createElement(_FormattedHTMLMessage.default, {
        message: "profileSidebarModule.integrations.viewAllItems",
        options: {
          count: itemCount
        }
      });
    }

    return _react.default.createElement("div", {
      className: "m-top-3"
    }, _react.default.createElement(_UILink.default, {
      href: allItemsLink,
      external: true
    }, message));
  },
  renderFooter: function renderFooter() {
    var _this$props2 = this.props,
        associatedObjectId = _this$props2.associatedObjectId,
        associatedObjectType = _this$props2.associatedObjectType,
        closeIframeModal = _this$props2.closeIframeModal,
        linkedSalesObject = _this$props2.linkedSalesObject,
        linkedSalesObjectContent = _this$props2.linkedSalesObjectContent,
        openIframeModal = _this$props2.openIframeModal;
    var appName = linkedSalesObject.get('appName');
    var objectTypeId = linkedSalesObject.get('objectTypeId');
    return _react.default.createElement(_ProfileIntegrationsLinkedSalesObjectFooter.default, {
      appName: appName,
      applicationId: linkedSalesObject.get('appId'),
      associatedObjectId: associatedObjectId,
      associatedObjectType: associatedObjectType,
      closeIframeModal: closeIframeModal,
      linkedSalesObject: linkedSalesObject,
      linkedSalesObjectContent: linkedSalesObjectContent,
      iframeParentTitle: appName,
      objectTypeId: objectTypeId,
      openIframeModal: openIframeModal
    });
  },
  renderIframeModal: function renderIframeModal() {
    var _this$props3 = this.props,
        activeIframe = _this$props3.activeIframe,
        closeIframeModal = _this$props3.closeIframeModal,
        linkedSalesObject = _this$props3.linkedSalesObject;

    if (!activeIframe) {
      return null;
    }

    return _react.default.createElement(_ProfileIntegrationsIframeModal.default, {
      activeIframe: activeIframe,
      applicationId: linkedSalesObject.get('appId'),
      appName: linkedSalesObject.get('appName'),
      closeIframeModal: closeIframeModal
    });
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: "integrations-extension"
    }, _react.default.createElement(_UISection.default, {
      className: "m-bottom-8"
    }, this.renderBody(), this.renderViewAllLink()), this.renderFooter(), this.renderIframeModal());
  }
});

exports.default = _default;
module.exports = exports.default;